const CREATE = 'create';
const EDIT = 'edit';
const DUPLICATE = 'duplicate';
const DELETE = 'delete';

export default Object.freeze({
    [CREATE]: 0,
    [EDIT]: 1,
    [DUPLICATE]: 2,
    [DELETE]: 3,
});
